import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import "../assets/style.scss"
import { useGetConfigMutation } from "../../../api/services"

const LandingHeader = () => {
  const [campaignText, setCampaignText] = useState('')

  const [getConfig] = useGetConfigMutation();
  useEffect(() => {
    getConfig("UniversiteliAkbankli.Landing.Top")
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setCampaignText(payload.configValue)
        }
      })
  }, [getConfig])
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="landing-header-text-wrapper">
        <Block className="landing-header-text">
          <Block dangerouslySetInnerHTML={{ __html: campaignText }} />
        </Block>
      </Block>
      <Image path={"./img/universiteliakbankli/landing-header-desktop-1.png"}
        className="landing-header-img" />
    </Block>
  )
}

export default LandingHeader
